import React from 'react';
import {
    TabContent,
    TabPane,
    Alert,
    Row,
    Col,
    Badge,
} from 'reactstrap';
import SimpleBar from 'simplebar-react';
import ActionMessage from './ActionMessage';
import { getActionSentTimeMs } from './actionUtils';
const AuthorizationDetailView = ({
    alert,
    activeTab,
    category,
    getDateTime,
    getDateAndTimeStamp,
    getUserActionLabelForHeader,
    showNonMediprocityUserAlert,
    renderDetailActionBar,
    renderActionsBar,
    renderDetailContent,
    variant = 'default',
    getLastAlertStage,
    checkAlertStatus,
    checkQuantity,
    checkSupply,
}) => {
    const a = alert;
    const isFlat = variant === 'flat';
    const useCustomDetail = typeof renderDetailContent === 'function';
    const hasActions = a?.hasOwnProperty('requestedActions') && a?.requestedActions?.length;
    const sortedActions = hasActions
        ? [...a.requestedActions].sort((x, y) => {
            const xTime = getActionSentTimeMs(x) ?? 0;
            const yTime = getActionSentTimeMs(y) ?? 0;
            return xTime - yTime;
        })
        : [];

    const renderDrugSection = () => {
        if (isFlat) {
            return (
                <>
                    <div className="d-flex justify-content-between">
                        <span>
                            Drug Label Name: <b>{a?.drugLabelName}</b>
                        </span>
                        <div>
                            <div style={{ whiteSpace: 'nowrap' }}>
                                Stage:
                                <Badge color="dark" className="ml-1 " style={{ fontSize: '14px' }}>
                                    {getLastAlertStage?.(a)}
                                </Badge>
                            </div>
                        </div>
                        <span className="ml-2">
                            <Badge color="secondary" className="ml-1" style={{ fontSize: '14px' }}>
                                {checkAlertStatus?.(a)}
                            </Badge>
                        </span>
                    </div>
                    <div>
                        Dispense Date: <b>{getDateTime(a?.dispenseDt)}</b>
                    </div>
                    <div>
                        RX Number: <b>{a?.rxNo}</b>
                    </div>
                    <div>
                        NDC: <b>{a?.ndc}</b>
                    </div>
                   {a?.sig && (
    <div>
        Sig: <b>{a.sig}</b>
    </div>
)}
                    <div className="d-flex justify-content-between">
                        {!checkQuantity?.(a) && (
                            <div>
                                Qty: <b>{a?.orgQty}</b>
                            </div>
                        )}
                        {checkQuantity?.(a) && (
                            <div>
                                Qty: <b>{a?.qty}</b>
                            </div>
                        )}
                        {checkQuantity?.(a) && (
                            <div>
                                Original Quantity: <b>{a?.orgQty}</b>
                            </div>
                        )}
                    </div>
                    <div className="d-flex justify-content-between">
                        <div>
                            Days Supply: <b>{a?.daysSupply}</b>
                        </div>
                        {checkSupply?.(a) && (
                            <div>
                                Original Days Supply: <b>{a?.orgDaysSupply}</b>
                            </div>
                        )}
                    </div>
                    <div>
                        Total Price: <b>${a?.ttlPrice}</b>
                    </div>
                </>
            );
        }
        return (
            <>
                <div>
                    Drug Label Name: <b>{a?.drugLabelName}</b>
                </div>
                <div>
                    Qty: <b>{a?.qty}</b>
                </div>
                {a?.minQtyDisp > 0 && (
                    <div>
                        Min Drug Qty: <b>{a.minQtyDisp}</b>
                    </div>
                )}
                <div>
                    Days Supply: <b>{a?.daysSupply}</b>
                </div>
                <div>
                    Total Price: <b>${a?.ttlPrice}</b>
                </div>
                {a?.invoiceGrp && (
                    <div>
                        Invoice Group: <b>{a.invoiceGrp}</b>
                    </div>
                )}
            </>
        );
    };

    return (
        <TabContent activeTab={activeTab}>
            <TabPane tabId="detail">
                    {useCustomDetail ? (
                        renderDetailContent(a)
                    ) : (
                        <>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <p>RX Number: </p>
                                    <span><b>{a?.rxNo}</b></span>
                                </div>
                                <div>
                                    <p>Dispense Date:</p>
                                    <span><b>{getDateTime(a?.dispenseDt)}</b></span>
                                </div>
                                <div>
                                    <p>Alerted On:</p>
                                    <span><b>{getDateTime(a?.alertCreatedOn)}</b></span>
                                    <span className="ml-2"><b>{getDateAndTimeStamp(a?.alertCreatedOn)}</b></span>
                                </div>
                            </div>
                            <hr />
                            <div>
                                Facility Name: <b>({a?.facID}) {a?.facName}</b>
                            </div>
                            <div>
                                Patient Name: <b>{a?.patName}</b>
                            </div>
                            <div>
                                <span>Nursing Station: <b>{a?.nsID}</b></span>
                                <span className="ml-2">Room: <b>{a?.room}</b></span>
                                <span className="ml-2">Bed: <b>{a?.bed}</b></span>
                            </div>
                            {!isFlat && a?.authBy && (
                                <div>
                                    Authorized By: <b>{a.authBy}</b>
                                </div>
                            )}
                            <hr />
                            {renderDrugSection()}
                            {(a?.srxStatus || a?.pharmacyStatus) && <hr />}
                            {a?.srxStatus && (
                                <h4 className="my-1">Resolution: {getUserActionLabelForHeader(a.srxStatus)}</h4>
                            )}
                            {a?.pharmacyStatus && (
                                <small>
                                    Pharmacy Resolution: <b>{a.pharmacyStatus}</b>
                                </small>
                            )}
                            <hr />
                            {showNonMediprocityUserAlert && (
                                <Alert color="danger" className="alert-link">
                                    SpecialtyRx Now credentials are required for user actions <br /> <br />
                                    <a href="/settings/specialtyRxNow">Set SpecialtyRx Now credentials</a>
                                </Alert>
                            )}
                            {renderDetailActionBar && (
                                <div
                                    className="bg-dark d-flex justify-content-end shadow"
                                    style={{ height: '45px', borderRadius: '3px' }}>
                                    {renderDetailActionBar(a)}
                                </div>
                            )}
                        </>
                    )}
                </TabPane>
                <TabPane tabId="actions">
                    <Row>
                        <Col>
                            <div className="d-flex justify-content-end align-items-center mb-1" />
                            {showNonMediprocityUserAlert && (
                                <Alert color="danger">
                                    <b>
                                        SpecialtyRx Now credentials are required for user actions <br /> <br />
                                        <a href="/settings/specialtyRxNow">Set SpecialtyRx Now credentials</a>
                                    </b>
                                </Alert>
                            )}
                            <div
                                style={{
                                    border: '1px solid #D6E0EC',
                                    borderTopLeftRadius: '3px',
                                    borderTopRightRadius: '3px',
                                    minHeight: '400px',
                                    maxHeight: '400px',
                                }}
                                className="shadow-sm action-display-simplebar-container">
                                {hasActions ? (
                                    <SimpleBar
                                        style={{
                                            maxHeight: '398px',
                                            minHeight: '398px',
                                            width: '100%',
                                        }}>
                                        <ul className="conversation-list mt-2">
                                            {sortedActions.map((action, i) => (
                                                <ActionMessage
                                                    key={i}
                                                    action={action}
                                                    i={i}
                                                    alert={a}
                                                    category={category}
                                                />
                                            ))}
                                        </ul>
                                    </SimpleBar>
                                ) : (
                                    <h5 className="text-center mt-3">
                                        <i>No recorded actions</i>
                                    </h5>
                                )}
                            </div>
                            {renderActionsBar && (
                                <div
                                    className="bg-dark d-flex justify-content-end"
                                    style={{
                                        height: '45px',
                                        borderBottomLeftRadius: '3px',
                                        borderBottomRightRadius: '3px',
                                    }}>
                                    {renderActionsBar(a)}
                                </div>
                            )}
                        </Col>
                    </Row>
                </TabPane>
            </TabContent>
    );
};

export default AuthorizationDetailView;
